import { PropType } from '@nuxtjs/composition-api'
import {
  NavigationSectionElement,
  NavigationSectionOptions,
  NormalizedSection,
} from 'contracts/Navigation'

export const navigationSectionProps = {
  props: {
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    sort: {
      type: Number,
      default: 0,
    },
    code: {
      type: String,
      default: '',
    },
    level: {
      type: Number,
      default: 0,
    },
    elements: {
      type: Array as PropType<NavigationSectionElement>,
      default: () => [],
    },
    children: {
      type: Array as PropType<NormalizedSection>,
      default: () => [],
    },
    options: {
      type: Object as PropType<NavigationSectionOptions>,
      default: () => {},
    },
    divider: {
      type: Boolean,
      default: false,
    },
    hideOnSubpage: {
      type: Boolean,
      default: false,
    },
  },
}
